import './App.scss';
import { useState, useEffect } from 'react';
import { Router, Location, Redirect, LocationProvider } from '@reach/router';
import { useMediaQuery } from 'react-responsive';
import ScrollToTopBtn from './components/menu/ScrollToTop';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Presale from './routes/Presale';

import MainHeader from './components/menu/MainHeader';

export const ScrollTop = ({ children, location }) => {
  useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

const PosedRouter = ({ children }) => (
  <Location>
    {({ location }) => (
      <div id='routerhang'>
        <div key={location.key}>
          <Router location={location}>
            {children}
          </Router>
        </div>
      </div>
    )}
  </Location>
);

function App() {
  const [isOpen, setIsOpen] = useState(true);
  const [navSelected, setNavSelected] = useState('');

  const isMobile = useMediaQuery({ maxWidth: '1024px' });

  useEffect(() => {
    window.addEventListener('load', (event) => {
      AOS.init();
      AOS.refresh();
    });
  }, []);


  return (
    <LocationProvider>
      <div className='app-container relative min-h-screen md:flex'>
        <div
          className={`flex-1 text-white min-h-screen flex-col overflow-hidden ${navSelected !== 'Home' ? '' : ''}`}
        >
          {/* THIS IS OUR HEADER */}
          {navSelected !== 'Home' && (
            <MainHeader setIsOpen={setIsOpen} navSelected={navSelected} />
          )}
          <div
            className='h-full lg:mt-[80px] mt-[180px]'
            onClick={() => {
              if (isMobile) {
                setIsOpen(false);
              }
            }}
          >
            <PosedRouter>
              <ScrollTop path="/">
                <Presale exact path="/">
                  <Redirect to="/" />
                </Presale>
              </ScrollTop>
            </PosedRouter>
          </div>
        </div>
        <ScrollToTopBtn />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
        />
      </div>
    </LocationProvider>
  );
}

export default App;
